import { ORDER_METHODS } from '../../../../services/exports/Constants';

export default {
  [ORDER_METHODS.delivery]: 'Livraison',
  [ORDER_METHODS.pickup]: 'À emporter',
  [ORDER_METHODS.on_site]: 'Commande à table',
};
